import katex from 'katex'
import 'katex/dist/katex.min.css'

/** Draw the formulas in rendered card HTML (`data-type` inline-math / block-math, `data-latex`). */
export function renderMath(root: HTMLElement) {
  for (const el of root.querySelectorAll<HTMLElement>(
    '[data-type="inline-math"], [data-type="block-math"]',
  )) {
    const latex = el.dataset.latex ?? ''
    try {
      katex.render(latex, el, {
        displayMode: el.dataset.type === 'block-math',
        throwOnError: false,
      })
    } catch {
      el.textContent = latex
    }
  }
}
